import { websiteLanguages } from '@formosa/shared/constants/websiteLanguages';
import { useEffect, useState } from 'react';
import { memberApi } from '@formosa/shared/api/member';
import { setStoredLocale } from '@formosa/shared/constants/locale';
import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import SettingsSubPageShell from '../../components/settings/SettingsSubPageShell';
import { useTranslation } from '../../i18n/LocaleContext';

export default function LanguagePage() {
  const { locale: selected, t } = useTranslation();
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function loadLanguages() {
      setLoading(true);
      setError('');
      try {
        const list = await memberApi.listLanguages();
        const rows = websiteLanguages(list);
        if (cancelled) {
          return;
        }
        setLanguages(rows);
        // Loading choices must not silently change the active locale.
      } catch {
        if (!cancelled) {
          setError('settings.loadLanguagesFailed');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadLanguages();
    return () => {
      cancelled = true;
    };
  }, []);

  function handleSelect(langCode) {
    setStoredLocale(langCode);
  }

  return (
    <SettingsSubPageShell title={t('settings.languageTitle')} centered>
      {loading && <p className="settings-language-status">{t('common.loading')}</p>}
      {error && <div role="alert" className="settings-alert settings-alert--error">{t(error)}</div>}

      {!loading && !error && (
        <ul className="settings-language-list">
          {languages.map((item) => {
            const isActive = item.langCode === selected;
            const iconUrl = item.langImgSquare || item.langImg;
            return (
              <li key={item.id ?? item.langCode}>
                <button
                  type="button"
                  className={`settings-language-item ${isActive ? 'is-active' : ''}`}
                  onClick={() => handleSelect(item.langCode)}
                >
                  <span className="settings-language-item__flag" aria-hidden>
                    {iconUrl ? (
                      <img src={resolveMemberMediaUrl(iconUrl)} alt="" className="settings-language-item__flag-img" />
                    ) : (
                      <span className="settings-language-item__flag-fallback">
                        {(item.langName || item.langCode || '?').slice(0, 1)}
                      </span>
                    )}
                  </span>
                  <span className="settings-language-item__label">
                    {item.langName || item.langNameCh || item.langCode}
                  </span>
                  <span className="settings-language-item__check" aria-hidden />
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </SettingsSubPageShell>
  );
}
